// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import { CSVLink } from 'react-csv';

import Card from '../../../ui/Card';
import Button from '../../../ui/Button';
import Table, {
  Th, Td, Tr, TableToolbar,
} from '../../../ui/Table';
import { RefreshIcon, DownloadIcon } from '../../../ui/icons';

const COLS = [
  ['day', 'Day'],
  ['source', 'UTM source'],
  ['medium', 'UTM medium'],
  ['domain', 'Domain'],
  ['forms_started', 'Forms started'],
  ['abandons', 'Abandons'],
  ['abandons_forms_started', 'Abandon rate'],
  ['unique_valid_abandoned_emails', 'Unique abandons w/ email'],
  ['submits', 'Submits'],
  ['emails_delivered', 'Emails delivered'],
  ['emails_opened', 'Emails opened'],
  ['unique_email_opens', 'Unique opens'],
  ['emails_clicked', 'Emails clicked'],
  ['unique_email_clicks', 'Unique clicks'],
  ['recaptures', 'Recaptures'],
];

class Analytics extends Component {
  state = { dataToDownload: [] };

  componentDidMount() {
    this.props.store.analytics.generateAnalytics();
  }

  download = () => {
    const { analyticsData } = this.props.store.analytics;
    const rows = [COLS.map(([, label]) => label)];
    Object.values(analyticsData).forEach((r) => {
      rows.push(COLS.map(([key]) => r[key]));
    });
    this.setState({ dataToDownload: rows }, () => {
      if (this.csvLink) this.csvLink.link.click();
    });
  }

  render() {
    const { analyticsData } = this.props.store.analytics;
    const rows = Object.values(analyticsData);

    return (
      <Card padded={false}>
        <TableToolbar
          title="Daily analytics"
          count={rows.length}
          right={(
            <>
              <Button icon={RefreshIcon} onClick={() => this.props.store.analytics.generateAnalytics()}>
                Regenerate
              </Button>
              <Button variant="primary" icon={DownloadIcon} onClick={this.download}>
                Export CSV
              </Button>
            </>
          )}
        />
        <Table>
          <thead>
            <tr>{COLS.map(([key, label]) => <Th key={key} align={key === 'day' || key === 'domain' || key === 'source' || key === 'medium' ? 'left' : 'right'}>{label}</Th>)}</tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <Tr key={i}>
                {COLS.map(([key]) => (
                  <Td key={key} align={key === 'day' || key === 'domain' || key === 'source' || key === 'medium' ? 'left' : 'right'} mono={!['day', 'domain', 'source', 'medium'].includes(key)}>
                    {r[key]}
                  </Td>
                ))}
              </Tr>
            ))}
          </tbody>
        </Table>
        <CSVLink
          data={this.state.dataToDownload}
          filename="analytics.csv"
          ref={(r) => { this.csvLink = r; }}
          style={{ display: 'none' }}
        />
      </Card>
    );
  }
}

export default inject('store')(observer(Analytics));
